// Adapted from https://github.com/rackt/react-modal
// Adapted from jQuery UI core

let focusableRegExp = /input|select|textarea|button|object/;

function focusable(element, isTabIndexNotNaN) {
    let nodeName = element.nodeName.toLowerCase();
    return (focusableRegExp.test(nodeName) 
                ? !element.disabled 
                : ("a" === nodeName 
                    ? (element.href || isTabIndexNotNaN)
                    : isTabIndexNotNaN)) 
            && visible(element);
}

function hidden(el) {
    return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
        el.style.display === 'none';
}

function visible(element) {
    while (element) {
        if (element === document.body) break;
        if (hidden(element)) return false;
        element = element.parentNode;
    }
    return true;
}

function tabbable(element) {
    let tabIndex = element.getAttribute('tabindex');
    if (tabIndex === null) tabIndex = undefined;
    let isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
    return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
        return tabbable(el);
    });
}

export default findTabbableDescendants;
